import React from 'react';
import { Link } from 'react-router';
import wNumb from 'wnumb';

let priceFormat = wNumb({
    prefix: '$',
    decimals: 0,
    thousand: ','
});

import { onEnquireClick } from '../../common/onEnquireClick';

const PackageSearchListItem = (props) => {

    let price = priceFormat.to(props.data.price);
    return (
        <div className="p-h-1-md house-land-list-item brd-bottom">
            <div className="cf">

                <div className="w-20-lg w-30 fl house-land-list-image">
                    <div className="relative">
                        <Link to={props.data.link}>
                            <img className="select-package-image" src={props.data.render} alt=""/>
                            <img className="select-package-builder-list dn db-md" src={props.data.logo} alt=""/>
                        </Link>
                    </div>
                </div>

                <div className="w-80-lg w-70 fl house-land-list-content">

                    <div className="w-100 w-60-md fl p-a-1-wd p-l-1">
                        <Link to={props.data.link}>
                            <p className="select-package-header small-blue-font m-b-1-md m-b-05"><span className="dn dib-md">Lot {props.data.lot} -</span> {props.data.name}</p>
                        </Link>

                        <div className="dn db-md">
                            <p className="small-grey-font m-b-1-md m-b-05 dn db-md">Land Size<span className="fcolor-og small-grey-font"> {props.data.area}m<sup>2</sup></span>
                                &nbsp;&nbsp;&nbsp;
                                Frontage<span className="fcolor-og small-grey-font"> {props.data.frontage}m</span></p>
                        </div>
                        <p className="medium-grey-font m-b-1-md m-b-05"><span className="fcolor-bl dib dn-md">Lot {props.data.lot}</span><span className="dib dn-md fcolor-og">&nbsp;&nbsp;{props.data.area}m<sup>2</sup> / {props.data.frontage}m</span></p>

                        <div className="">
                            <ul>
                                <li> <span>{props.data.bed}</span>&nbsp;<img className="fr" src='https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/bed.svg' alt="" width="25px"/></li>
                                <li>&nbsp;&nbsp;<span>{props.data.bath}</span>&nbsp;<img className="fr" src='https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/bathtub.svg' alt="" width="25px"/></li>
                                <li>&nbsp;&nbsp;<span>{props.data.car}</span>&nbsp;<img className="fr" src='https://storage.googleapis.com/windermere.data.insiteinteractive.com.au/assets/images/icons/car.svg' alt="" width="25px"/></li>
                            </ul>
                        </div>

                    </div>


                    <div className="w-40-md fl p-a-1-wd p-a-0 dn db-md tr-md">
                        <p className="house-package-price m-b-1-wd m-b-05-lg"><span className="small-grey-font">From  </span>{price}</p>

                        <div className="db  m-b-1">
                            <a className="btn btn__action--rev w-80-lg w-100" href={props.data.pdf + '?package=' + props.data.id} target="_blank">
                                <i className="icon icon--download"></i>
                                    <span>DOWNLOAD <span className="dn dib-lg"> FLYER</span></span>
                            </a>
                        </div>

                        <div className="db">
                            <a className="btn btn__enquire js-registrationModal" role="button" onClick={(ev) => onEnquireClick(ev,  props.data.builder, props.data.name, props.data.lot)}>
                                <span className="btn-land-available">ENQUIRE</span>
                            </a>
                        </div>
                    </div>

                </div>

            </div>

            <div className="cf">
                <div className="w-100 dn-md db">
                    <div className="w-50 fl">
                        <p className="house-package-price m-b-0"><span className="small-grey-font">From  </span>{price}</p>
                    </div>

                    <div className="w-50 fr di">
                        <a className="btn-enquire-mob js-registrationModal fr" onClick={(ev) => onEnquireClick(ev, props.data.builder, props.data.name, props.data.lot)}>
                            <i className="icon icon--mail-house"></i>
                        </a>
                        <a className="download-flyer fr" href={props.data.pdf + '?package=' + props.data.id} target="_blank">
                            <i className="icon icon--download-house"></i>
                        </a>

                    </div>


                </div>
            </div>
        </div>
    );
};

export default PackageSearchListItem;


/** WEBPACK FOOTER **
 ** ./src/modules/house-and-land/elements/PackageSearchListItem.js
 **/